export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 7_09.49923a8c.jpg";